module.exports = __webpack_public_path__ + "img/golf.ce540d1c.png";